var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#1163C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0488 16.0669C9.7505 16.0669 9.49965 15.841 9.46801 15.5438L8.50191 6.39802C8.47818 6.16751 8.42281 5.94604 8.33807 5.73926C8.33807 5.73926 8.34146 5.74491 8.34259 5.74943C8.15954 5.36977 7.77084 5.12457 7.35163 5.12457C6.74598 5.12457 6.25332 5.61722 6.25332 6.22287C6.25332 6.54604 5.99118 6.80706 5.66914 6.80706C5.34711 6.80706 5.08496 6.54491 5.08496 6.22287C5.08496 4.97316 6.10191 3.95508 7.35276 3.95508C8.21716 3.95508 9.01942 4.45903 9.3957 5.23756C9.39909 5.24547 9.40926 5.26694 9.42168 5.29632C9.54824 5.60593 9.62959 5.93474 9.66575 6.27485L10.059 9.9935L10.4714 6.19237C10.4985 5.94378 10.5516 5.69745 10.6285 5.46016C10.6612 5.35847 10.6714 5.33248 10.6838 5.3031C11.0499 4.48276 11.8624 3.95508 12.7573 3.95508C14.0081 3.95508 15.0251 4.97203 15.0251 6.22287C15.0251 6.54604 14.7629 6.80706 14.4409 6.80706C14.1189 6.80706 13.8567 6.54491 13.8567 6.22287C13.8567 5.61722 13.3641 5.12457 12.7584 5.12457C12.3313 5.12457 11.9426 5.37316 11.7618 5.7596C11.7561 5.77542 11.7494 5.79689 11.7415 5.82287C11.6884 5.98446 11.6533 6.15169 11.6352 6.31892L10.6341 15.546C10.6025 15.8432 10.3516 16.0669 10.0533 16.0669H10.0488Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAries);
export default __webpack_public_path__ + "static/media/aries.71907ebcff375872d8e96cf7f97f1b9e.svg";
export { ForwardRef as ReactComponent };